import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { State, Mutation } from 'vuex-class';
import Moment from 'moment';
import { ILOGPRE } from '@/types/base.d';
import { IContract } from '@/types/org.d';
import api from '@/api/org';

@Component
export default class formMixin extends Vue {
  @State(state => state.org.curComp) curComp!: string;

  @Mutation('org/SET_ORG_BTN_COMPENT') setCurComp!: Function;

  @Mutation('org/SET_ORG_COMPENT_REFRESH') handleRerfesh!: Function;

  public log: ILOGPRE = {
    name: '机构管理 - 合同 - 模态框 -',
    component: 'org/manage/components/bModal',
  };

  public form: IContract = {
    orgPid: '',
    startTime: '',
    endTime: '',
    remark: '',
  };

  private loading: boolean = false;

  private startVali = (rule: any, value: any, callback: Function) => {
    if (new Date(value).getTime() > new Date(this.form.endTime).getTime()) callback(new Error('开始时间应小于结束时间'));
    else callback();
  };

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    startTime: [
      { required: true, message: '结束时间不能为空' },
      { validator: this.startVali, trigger: 'blur' },
    ],
    endTime: [
      { required: true, message: '结束时间不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }

  /**
   * @author Terry
   * @description 提交Form 完成后执行此方法
   */
  submitFinish() {
    this.reset(true, true);
    this.loading = false;
    if (this.curComp !== 'Contract') this.setCurComp('Contract');
    else this.handleRerfesh(true);
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑合同
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        this.form.startTime = Moment(this.form.startTime).format('YYYY-MM-DD');
        this.form.endTime = Moment(this.form.endTime).format('YYYY-MM-DD');
        if (title.includes('编辑')) {
          api.editContract(this.form).then(() => {
            this.submitFinish();
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.addContract(this.form).then(() => {
            this.submitFinish();
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }
}
